import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Link } from 'react-router';
import { api } from '../api/client';
import { API_TOKENS_KEY } from '../pages/account/ApiTokensPanel';
import { CONNECTED_APPS_KEY } from '../pages/account/ConnectedAppsPanel';
import { CopyField } from './CopyField';

const HIDDEN_KEY = 'couch.connectClaudeHint.hidden';

function readHidden(): boolean {
  try {
    return localStorage.getItem(HIDDEN_KEY) === '1';
  } catch (error) {
    console.warn('connect-Claude hint: browser storage unavailable, the hint stays', error);
    return false;
  }
}

/**
 * Where people find how to add Couch to their Claude app (doc 37) — shown until an app is connected or an
 * API token has been used. Nothing shows while either list is loading or failed: no nagging on errors.
 */
export function ConnectClaudeHint() {
  const [hidden, setHidden] = useState(readHidden);
  const apps = useQuery({ queryKey: CONNECTED_APPS_KEY, queryFn: api.connectedApps, enabled: !hidden });
  const tokens = useQuery({ queryKey: API_TOKENS_KEY, queryFn: api.apiTokens, enabled: !hidden });
  if (hidden || !apps.isSuccess || !tokens.isSuccess) return null;
  if (apps.data.apps.length > 0 || tokens.data.tokens.some((t) => t.lastUsedAt !== null)) return null;
  const hide = () => {
    try {
      localStorage.setItem(HIDDEN_KEY, '1');
    } catch (error) {
      console.warn('connect-Claude hint: could not remember "Not now"', error);
    }
    setHidden(true);
  };
  return (
    <section className="panel connect-hint" aria-labelledby="connect-hint-title">
      <h2 id="connect-hint-title">Use Couch from your Claude app</h2>
      <p>
        In Claude (desktop, web or phone): Settings → Connectors → Add custom connector, and paste this URL.
        Claude then asks you here to allow it — no token to copy.
      </p>
      <CopyField value={`${window.location.origin}/api/v1/mcp`} label="Connector URL" />
      <p className="muted">Claude Code in a terminal, RunPod and more: <Link to="/connections">Connections</Link>. Connected apps and API tokens: <Link to="/account">Account</Link>.</p>
      <button type="button" className="button-quiet" onClick={hide}>Not now</button>
    </section>
  );
}
